module.exports = __webpack_public_path__ + "static/media/mitra-logo-transparent.6bec67ed.svg";